import { mapEnumToOptions } from '@abp/ng.core';

export enum DeallocationType {
  AWAITINGCOLLECTION = 'AWAITINGCOLLECTION',
  CONTAINER = 'CONTAINER',
  ONSITE = 'ONSITE',
}

export const deallocateTypeOptions = mapEnumToOptions(DeallocationType);
